




import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			showReceptionIframe: true,
		};
	},
	computed: {
		wmsFinalInspection() {
			return `${this.dmsSys.DMSC_url}/wms/WmsFinalInspection`;
		},
	},
});
